import React from 'react';
import {
	CSSZAddress,
	CSSZSickLeaveCertificate,
	CSSZUser,
} from '../../Interfaces/CSSZ.interface';
import useCSSZSickLeaveForm from '../Hooks/useCSSZSickLeaveForm';
import CSSZSickLeaveCertificateEndOfSickLeaveForm, {
	CSSZSickLeaveCertificateEndOfSickLeaveFormValues,
} from './CSSZSickLeaveCertificateEndOfSickLeaveForm';
import styles from './CSSZSickLeaveCertificateEndOfSickLeave.module.scss';
import CSSZSickLeaveCertificateFormPartA from '../CSSZSickLeaveCertificateCreate/FormParts/CSSZSickLeaveCertificateFormPartA';
import CSSZSickLeaveCertificateFormHeadline from '../CSSZSickLeaveCertificateCreate/FormParts/CSSZSickLeaveCertificateFormHeadline';
import CSSZAddressPreview from '../CSSZSickLeaveCertificateCreate/FormParts/CSSZAddressPreview';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import Loading from '../../../../Components/Loading';
import useCSSZSickLeaveSender from '../Hooks/useCSSZSickLeaveSender';

interface Props {
	user: CSSZUser;
	item: CSSZSickLeaveCertificate;
	onCreate: () => void;
}

export type CSSZSickLeaveCertificateEndOfSickLeaveValues = Omit<
	CSSZSickLeaveCertificateEndOfSickLeaveFormValues,
	'diagnosis'
> & {
	diagnosis: string;
};

const CSSZSickLeaveCertificateEndOfSickLeave: React.FC<Props> = ({
	item,
	onCreate,
	user,
}) => {
	const { post, isLoading } = useCSSZSickLeaveForm({
		patientId: user.id,
		sickLeaveCertificate: item,
		endpoint: 'solve',
	});

	const handleSubmit = async (
		values: CSSZSickLeaveCertificateEndOfSickLeaveFormValues,
	) => {
		const payload = {
			...values,
			diagnosis: values.diagnosis.value as string,
		};
		await post(payload, onCreate);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<CSSZSickLeaveCertificateFormPartA user={user} />
			<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartB.title' />
			<CSSZAddressPreview address={user.profile?.address as CSSZAddress} />
			<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartC.title' />
			<CSSZSickLeaveCertificateEndOfSickLeaveForm onSubmit={handleSubmit} />
		</div>
	);
};
export default CSSZSickLeaveCertificateEndOfSickLeave;
